import React from "react";
import styled from "styled-components";
import { useCartContext } from "../context/cart_context";
import { Link } from "react-router-dom";
import { CartContent, PageHero } from "../components";

const CartPage = () => {
  const { cart } = useCartContext();
  if (cart.length < 1) {
    return (
      <Wrapper>
        <div className="empty page-100">
          <div>
            <h2>There are no products!</h2>
            <Link to="./products" className="btn">
              Fill it
            </Link>
          </div>
        </div>
      </Wrapper>
    );
  }
  return (
    <>
      <PageHero title="cart"></PageHero>
      <CartContent className="page"></CartContent>
    </>
  );
};

const Wrapper = styled.main`
  .empty {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    h2 {
      margin-bottom: 1rem;
      text-transform: none;
    }
  }
`;

export default CartPage;
